module.exports = __webpack_public_path__ + "static/qbo-logo-7dc7f63ba877e30deb423fe2948891e0.svg";